import { render, staticRenderFns } from "./Psd2SkipModal.vue?vue&type=template&id=a55ccda8&scoped=true&"
import script from "./Psd2SkipModal.vue?vue&type=script&lang=js&"
export * from "./Psd2SkipModal.vue?vue&type=script&lang=js&"
import style0 from "./Psd2SkipModal.vue?vue&type=style&index=0&id=a55ccda8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55ccda8",
  null
  
)

export default component.exports